import { useState } from "react";
import { api } from "../../../helpers/api";
import Button from "../../../components/Button";
import { PopupModal } from "../../../components/Modal";
import { ShowToast } from "../../../components/toast";

export function ConfirmBlock({
  onClose,
  userId,
  refetch,
  isActive,
}: {
  onClose: () => void;
  userId: string;
  refetch: () => void;
  isActive: boolean;
}) {
  const [blocking, setBlocking] = useState(false);
  const handleBlock = () => {
    setBlocking(true);
    api
      .updateUser(userId, isActive ? false : true)
      .then(() => {
        setBlocking(false);
        onClose();
        ShowToast({
          message: isActive
            ? "User deactivated successfully"
            : "User activated successfully",
          type: "success",
        });
        refetch && refetch();
      })
      .catch((err) => {
        setBlocking(false);
        ShowToast({
          message:
            err.response.data.message ||
            `Failed to ${isActive ? "deactivate" : "activate"} user`,
          type: "error",
        });
      });
  };

  return (
    <PopupModal onClose={onClose} contentClassName="w-[500px] mx-auto">
      <p>
        Are you sure you want to {isActive ? "deactivate" : "activate"} this
        user?
      </p>
      <div className="flex flex-row gap-4 ml-auto">
        <Button
          variant="outline"
          className="px-8"
          onClick={onClose}
          disabled={blocking}
        >
          Cancel
        </Button>
        <Button
          className="px-8 text-[1rem]"
          onClick={handleBlock}
          loading={blocking}
        >
          {isActive ? "Deactivate" : "Activate"}
        </Button>
      </div>
    </PopupModal>
  );
}
